<template>
	<a :href="href">{{value}}</a>
</template>
<script>
export default {
	props: {
		customClass: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: '',
		}
	},
	computed: {
		href() {
			return `mailto:${this.value}`
		}
	}
}
</script>